module.exports = __webpack_public_path__ + "img/domestic-2013-terms.6836375f.jpg";